import { getBreakpoints } from '../utils/utils';

(function ($) {
  const PICTURE_SELECTOR = '.content-box__picture, .featured-offer__slider';

  // Pictures settle after `load`: lazy images get their `src` from Swiper, the
  // per-block CSS/JS bundles arrive separately and Swiper lays the slides out.
  // On a slow connection the first measurement therefore reports a picture that
  // is shorter than the controls under the excerpt, `additionalHeight` goes
  // negative, jQuery clamps it to `height: 0px` and the excerpt disappears.
  // Re-measure whenever a picture changes size instead of trusting that value.
  const observedPictures = new WeakSet();
  const watchedImages = new WeakSet();
  let scheduledFrame = null;

  function getPictureHeight(container) {
    const picture = container.find(PICTURE_SELECTOR);
    return picture.length ? picture.height() : 0;
  }

  function getExpanderHeight(container) {
    const expander = container.find('.c-expander__button');
    const expanderHeight = expander.outerHeight(true);
    return expanderHeight;
  }

  function getMoreLinksHeight(container) {
    const moreLinks = container.find('.content-box__more-wrapper');
    const moreLinksHeight = moreLinks.outerHeight(true);
    return moreLinksHeight;
  }

  function getReferenceHeight(container) {
    const reference = container.find('.content-box__reference');
    const referenceHeight = reference.outerHeight(true);
    return referenceHeight;
  }

  function getButtonHeight(container) {
    const button = container.find('.content-box__button, .featured-offer__button');
    const buttonHeight = button.outerHeight(true);
    return buttonHeight;
  }

  function getAdditionalHeight(container) {
    const pictureHeight = getPictureHeight(container);
    const expanderHeight = getExpanderHeight(container);
    const moreLinksHeight = getMoreLinksHeight(container);
    const referenceHeight = getReferenceHeight(container);
    const buttonHeight = getButtonHeight(container);
    const additionalHeight = pictureHeight - ((expanderHeight !== undefined ? expanderHeight : 0)
      + (moreLinksHeight !== undefined ? moreLinksHeight : 0)
      + (referenceHeight !== undefined ? referenceHeight : 0)
      + (buttonHeight !== undefined ? buttonHeight : 0));
    return additionalHeight;
  }

  function hideExpander(expander) {
    expander.find('.c-expander__shadow').hide();
    expander.find('.c-expander__button').hide();
    expander.find('.c-expander__button-label').removeClass('expanded');
    expander.find('.c-expander__excerpt').height('').removeClass('expanded');
  }

  function refreshTabindex() {
    const $container = $('.c-expander__excerpt-inner a');
    $container.overflowing('.c-expander__excerpt', (overflowed) => {
      if (overflowed instanceof $) {
        overflowed.find('a').each(function () {
          const excerptWrapper = $(this).closest('.c-expander__excerpt');
          if (excerptWrapper.length) {
            if ($(this).offset().top > excerptWrapper.offset().top + excerptWrapper.height()) {
              $(this).attr('tabindex', -1);
            }
          }
        });
      }
    });
  }

  function toggleExpander(element) {
    const curContentBoxContainer = $(element).closest('.content-box');
    const curExpanderContainer = $(element).closest('.c-expander');
    const curContainer = curContentBoxContainer.length ? curContentBoxContainer
      : curExpanderContainer;

    const container = $(element).closest('.content-box__container, .featured-offer');

    const curShadow = curContainer.find('.c-expander__shadow');
    const curExcerpt = curContainer.find('.c-expander__excerpt');
    const curDetails = curContainer.find('.content-box-details');
    const curButtonLabel = curContainer.find('.c-expander__button-label');

    curShadow.toggleClass('expanded');
    curExcerpt.toggleClass('expanded');
    curButtonLabel.toggleClass('expanded');

    if (curExcerpt.hasClass('expanded')) {
      curExcerpt.find('a').attr('tabindex', 0);
      curExcerpt.height('');
    } else if (container.length) {
      const additionalHeight = getAdditionalHeight(container);
      // A non-positive height means the picture is not measurable yet; leaving
      // the excerpt at its natural height beats collapsing it to nothing.
      curExcerpt.height(additionalHeight > 0 ? additionalHeight : '');
      refreshTabindex();
    } else {
      curExcerpt.height('');
      refreshTabindex();
    }

    if (curDetails.length) {
      curDetails.toggleClass('content-box-details__expanded').find('.c-expander__button-label.expanded').focus();
      curButtonLabel.toggleClass('expanded d-none');
    }
  }

  // `preserveExpanded` keeps an already open excerpt open. A picture resizing is
  // not a user action: `.featured-offer__slider` is a Swiper with
  // `autoHeight: true`, so its height changes on every slide change, and a
  // re-measure there would collapse an excerpt the visitor has just expanded.
  function showButton(preserveExpanded) {
    const $expander = $('.c-expander');

    $expander.each(function () {
      const curExpander = $(this);

      if (curExpander.closest('.content-slider__container').length) {
        return;
      }

      const container = curExpander.closest('.content-box__container, .featured-offer');
      const pictureHeight = getPictureHeight(container);
      const offerInner = container.find('.featured-offer__inner');
      const curShadow = curExpander.find('.c-expander__shadow');
      const curButton = curExpander.find('.c-expander__button');
      const curExcerpt = curExpander.find('.c-expander__excerpt');
      const buttonLabel = curExpander.find('.c-expander__button-label');
      const isExpanded = curExcerpt.hasClass('expanded');

      if (isExpanded && preserveExpanded) {
        return;
      }

      // Collapse through `toggleExpander` first so the details block and the
      // button labels follow the excerpt. `hideExpander` below only clears the
      // excerpt itself, and it strips the `expanded` class this check needs.
      if (isExpanded && buttonLabel.length) {
        toggleExpander(buttonLabel[0]);
      }

      hideExpander(curExpander);

      if ($(window).width() < getBreakpoints().lg) {
        return;
      }

      const curExcerptHeight = curExcerpt.height();
      const curExcerptInner = curExpander.find('.c-expander__excerpt-inner');
      let curExcerptInnerHeight = curExcerptInner.prop('scrollHeight');
      const additionalHeight = getAdditionalHeight(container);

      if (offerInner.length) {
        curExcerptInnerHeight = offerInner.prop('scrollHeight');
      }

      if (curExcerptInnerHeight > curExcerptHeight + 2 && curExcerptInnerHeight > 0) {
        curButton.show();
        curShadow.show();
      } else {
        hideExpander(curExpander);
      }

      if (container.length) {
        // `pictureHeight` and `additionalHeight` are only trustworthy once the
        // picture has a real size; until then keep the excerpt fully visible.
        if (pictureHeight > 0 && additionalHeight > 0
          && curExcerptInnerHeight > pictureHeight + 2) {
          curButton.show();
          curShadow.show();
          curExcerpt.height(additionalHeight);
        } else {
          hideExpander(curExpander);
        }
      }
    });
  }

  function scheduleShowButton() {
    if (scheduledFrame !== null) {
      return;
    }

    scheduledFrame = window.requestAnimationFrame(() => {
      scheduledFrame = null;
      showButton(true);
      refreshTabindex();
    });
  }

  function observePicture(picture) {
    if (observedPictures.has(picture) || typeof window.ResizeObserver !== 'function') {
      return;
    }
    observedPictures.add(picture);

    // ResizeObserver reports the current size as soon as it starts observing,
    // so compare against it to skip that first redundant re-measure.
    let lastHeight = picture.offsetHeight;
    const observer = new window.ResizeObserver(() => {
      if (picture.offsetHeight === lastHeight) {
        return;
      }
      lastHeight = picture.offsetHeight;
      scheduleShowButton();
    });
    observer.observe(picture);
  }

  function watchPictures() {
    $(PICTURE_SELECTOR).each(function () {
      observePicture(this);

      // Fallback for browsers without ResizeObserver. A Swiper lazy image
      // carries only `data-src`, and `complete` is true for an image with no
      // `src` at all, so check that something has actually been decoded.
      $(this).find('img').each(function () {
        if ((this.complete && this.naturalHeight > 0) || watchedImages.has(this)) {
          return;
        }
        watchedImages.add(this);
        $(this).one('load error', scheduleShowButton);
      });
    });
  }

  $(document).ready(watchPictures);
  $(window).on('load resize', () => {
    showButton();
    refreshTabindex();
    watchPictures();
  });
  $(document).on('click', '.c-expander__button-label', (event) => {
    toggleExpander(event.target);
  });

  // The app bundle can be deferred/delayed past `load`, and jQuery does not
  // replay an event that already fired.
  if (document.readyState === 'complete') {
    scheduleShowButton();
    watchPictures();
  }
}(jQuery));  // eslint-disable-line
export default true;
